import { CompanyDto } from '@domain/rs/search/CompanyListRs';
import NumberFormat from '@utils/number/format';

export default class CompanyVO {
  sn: number;
  name: string;
  logoImageUrl: string;
  locationCode: number;
  locationName: string;
  vision: string;
  numberOfPositions: number;

  constructor(rs: CompanyDto) {
    this.sn = rs.sn;
    this.name = rs.name;
    this.logoImageUrl = rs.logoImageUrl;
    this.locationCode = rs.locationCode;
    this.locationName = NumberFormat.formatLocationName(this.locationCode);
    this.vision = rs.vision;
    this.numberOfPositions = rs.numberOfPositions;
  }
}
